import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-108">
          Your investment is 100% protected
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-8 tracking-tight" data-id="element-109">
          7-Day Total{' '}
          <span className="italic text-pilates-sage-dark" data-id="element-110">Guarantee</span>
        </h2>

        <div className="bg-white rounded-3xl p-8 sm:p-10 shadow-lg border border-pilates-sage/20 relative" data-id="element-111">
          <div className="bg-gradient-to-br from-pilates-sage to-pilates-sage-dark w-20 h-20 rounded-full flex items-center justify-center shadow-xl mx-auto mb-6" data-id="element-112">
            <ShieldCheck className="w-10 h-10 text-white" data-id="element-113" />
          </div>

          <h3 className="font-display text-2xl font-semibold text-pilates-dark mb-4" data-id="element-114">
            Your money is 100% protected
          </h3>
          <p className="text-pilates-slate text-base sm:text-lg leading-relaxed" data-id="element-115">
            You have 7 full days to explore the 6 guides, apply the sequences in
            the studio, and evaluate the results. If you are not fully
            satisfied, we will refund 100% of your money. Zero risk for you,
            total commitment from us.
          </p>
        </div>
      </div>
    </section>;
}